import styled from "styled-components";

export const BannerInner = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1224px;
  margin: 0 auto;
  position: relative;
  animation: none;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

export const BannerItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
